import { axios } from './index'
const resource = "/v1/stay";

export default {
  /**
   * 支払方法設定要否判断
   */
  getMustHavePaymentCheck(){
    return axios.get(`${resource}/pp/payment-method`);
  },
}